import React, { Component } from 'react';
import $ from "jquery";
import './lokalin.css'
import './lokalin-responsive.css'
import Favicon from 'react-favicon';
import HeaderSearch from "../headerComponents/headerSearch"
// import HeaderUpload from "../headerComponents/HeaderUpload"
import HeaderLogo from "../headerComponents/headerLogo"
import HeaderBookTable from "../headerComponents/headerBookTable"
import HeaderCart from "../headerComponents/headerCart"
import HeaderLocationName from "../headerComponents/headerLocationName"
import HeaderLocation from "../headerComponents/headerLocation"
import HeaderLogin from "../headerComponents/headerLogin"
import HeaderStore from "../headerComponents/headerStore"
import HeaderCategory from "../headerComponents/headerCategory"
import LoginButton from "../headerComponents/loginButtons"
import Globalsearch from './globalSearch';
import { Style } from "react-style-tag";
import StartShopping from './startShopping';

var themeId = localStorage.getItem('themeId');
export default class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {
    var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
    let locationId = localStorage.getItem('locationId');
    if (subDomainFlag === '1' && (locationId === 'null' || locationId === null || locationId === '')) {
      $(".locationPopUp").show();
    }
    $("#txtSearch").focus();
    $(".popOverlay").click(function () {
      if (subDomainFlag === '1') {
        if (locationId !== 'null' && locationId !== null && locationId !== '') {
          $(".popupWrap").hide();
        }
        else {
          $(".popupWrap").show();
        }
      }
      else {
        $(".popupWrap").hide();
      }
    });
    $(document).mouseup(function (e) {
      var menuContainer = $(".sideMenuDiv");
      if (!menuContainer.is(e.target) // if the target of the click isn't the container...
        && menuContainer.has(e.target).length === 0) // ... nor a descendant of the container
      {
        if (subDomainFlag === '1') {
          if (locationId !== 'null' && locationId !== null && locationId !== '') {
            menuContainer.hide();
          }
        }
        else {
          menuContainer.hide();
        }
      }
    });
    if (themeId === '29') {
      if (window.sessionStorage.getItem('pageLoad') === null) {
        window.sessionStorage.setItem('pageLoad', true)
        window.location.reload();
      }
    }
  }
  render() {
    let sessionSiteDetails = window.sessionStorage.getItem('siteDetails');
    var siteDetails = JSON.parse(sessionSiteDetails);
    let storeLogoPathSmall = siteDetails.siteData[0].logoPathSML;
    let storeLogoPath = siteDetails.siteData[0].logoPath;
    let userId = localStorage.getItem('userId');
    let isHeaderIconHide = '0'
    var siteUrlHeader = window.location.href;
    var siteUrlPathname = window.location.pathname;
    console.log(siteUrlPathname, "homepage", window.location.host)
    console.log(typeof (siteUrlHeader.indexOf("OrderSummary")), "first", typeof (siteUrlHeader.indexOf("viewOrder")))
    if (siteUrlHeader.indexOf("OrderSummary") !== -1 || siteUrlHeader.indexOf("viewOrder") !== -1) {
      isHeaderIconHide = '1'
    }
    if (siteUrlPathname !== "/" && siteUrlPathname !== "/category" && siteUrlPathname !== "/store" && siteUrlPathname !== "/globalSearchResult") {
      isHeaderIconHide = '1'
    }
    let themeCustomColor = siteDetails.siteData[0].themeCustomColor
    return (
      <div className={"header " + (userId ? "divAfterUserLogin " : "") + (isHeaderIconHide === "1" ? "productSearchDivSection" : "")}>
        {themeCustomColor.length > 0 ?
          <Style>
            {`
            :root {
              --header-bg-color: `+ themeCustomColor[0] + `; 
              --header-cart-bg: `+ themeCustomColor[1] + `;
              --header-cart-text: `+ themeCustomColor[2] + `;
              --common-color: `+ themeCustomColor[3] + `;
              --price-color: `+ themeCustomColor[4] + `;
              --header-text-color: `+ themeCustomColor[5] + `;
              --middle-color: `+ themeCustomColor[6] + `;
              --heading-color: `+ themeCustomColor[7] + `;
              --color: `+ themeCustomColor[8] + `;
              --bg-color: `+ themeCustomColor[9] + `;
              --location-color: `+ themeCustomColor[10] + `;
              --banner-btn:`+ themeCustomColor[11] + `;
              --header-top-bg-color: `+ themeCustomColor[12] + `;
              --header-top-color: `+ themeCustomColor[13] + `;
              --header-text-color: `+ themeCustomColor[14] + `;
              --header-button-bg: `+ themeCustomColor[15] + `;
              --header-button-text: `+ themeCustomColor[16] + `;
              --category-bg: `+ themeCustomColor[17] + `;
              --category-color: `+ themeCustomColor[18] + `;
              --common-button-bg: `+ themeCustomColor[19] + `;
              --common-button-color: `+ themeCustomColor[20] + `;
              --continue-shopping: `+ themeCustomColor[21] + `;
              --preview-btn-bg: `+ themeCustomColor[22] + `;
              --search-btn-bg: `+ themeCustomColor[23] + `;
              --search-btn-txt-clr: `+ themeCustomColor[24] + `;
              --analytics_bg: `+ themeCustomColor[25] + `;
              --middle-color: `+ themeCustomColor[26] + `;
              --common-color-light: `+ themeCustomColor[27] + `; 
             
            }
          `}
          </Style>
          :
          ""
        }
        <header>
          <Favicon url={storeLogoPathSmall} />
          <div className="headerBottom">
            <div className="container header-rightWrapper">
              <HeaderLogo fromPage={"Lokal"} storeLogoPath={storeLogoPath}></HeaderLogo>
              <div className="shopping-btn-outer">
                {/* {siteUrlPathname === "/" &&
                  <div className="shopping-button-header">{(localStorage.getItem('siteGlobalDelivery') === "true") && <StartShopping />} </div>
                } */}
                <div className={"headerRight " + (userId ? "iconsMoveToRight" : "")}>
                  <div className="gsa-header-center">
                    {console.log("ocalStorage.getItem('hasGlobalSearch')",localStorage.getItem('hasGlobalSearch'))}
                  {localStorage.getItem('hasGlobalSearch') == "false" ?
                    <HeaderSearch></HeaderSearch>
                   : 
                     <Globalsearch /> 
                     } 
                    {/* <HeaderUpload></HeaderUpload> */}
                    {localStorage.getItem('hasGlobalSearch') == "false" ? 
                    <HeaderCategory></HeaderCategory>
                    :""} 
                    <HeaderLocation></HeaderLocation>
                    {localStorage.getItem('hasGlobalSearch') == "false" ? 
                    <HeaderStore></HeaderStore> :""} 

                    {userId ? <HeaderLogin></HeaderLogin> : ""}
                    {/* {(localStorage.getItem('siteGlobalDelivery') === "true") && <StartShopping/>}  */}
                    {/* <div className="shopping-button-header">{(localStorage.getItem('siteGlobalDelivery') === "true") && <StartShopping/>} </div> */}
                    <HeaderCart></HeaderCart>
                    <HeaderBookTable></HeaderBookTable>
                    <HeaderLocationName></HeaderLocationName>
                  </div>
                </div>
                {userId ? "" : <LoginButton></LoginButton>}
              </div>
            </div>
           
          </div>

        </header>
      </div>
    );
  }
}
